import { Download } from "lucide-react"
import { PlaceholderPage } from "./placeholder-page"

export function DataExportPage() {
  return (
    <PlaceholderPage
      icon={Download}
      title="Eksport danych"
      description="Eksportuj dane z systemu do plik\u00F3w CSV lub Excel."
    />
  )
}
